module.exports = __webpack_public_path__ + "static/office_outing-21d34a048654fca92f6c263cdbd826ef.jpg";